import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className';

// MUI 4 and MUI 5 both put global hook classes such as `MuiButton-root` on their elements, and v4
// also *styles* through them. With both on a page, v4's global sheets restyle v5 elements (a v5
// Button loses its padding to v4's `.MuiButtonBase-root` reset, a v5 Tab takes v4's Tab sizes).
// Prefixing the v5 names keeps the two apart: v5 elements carry `v5-MuiButton-root`, state classes
// (`Mui-disabled`, `Mui-checked`, ...) are unchanged.
//
// Must run before any @mui/material component module is evaluated - keep this import first in the
// bundle entries (main.js, mainBiz.js); Jest loads it through `setupFiles`.
ClassNameGenerator.configure((componentName) => `v5-${componentName}`);
